import styled from 'styled-components';

const StyledMedicalLeaveForm = styled.form.attrs({ id: 'ezla-form' })`
   display: flex;
   width: 100%;
   padding-right: 10px;
   flex-wrap: wrap;
   gap: 32px;
`;
StyledMedicalLeaveForm.displayName = 'StyledMedicalLeaveForm';

export { StyledMedicalLeaveForm };
